import React, {useState, useEffect, useRef} from "react";
import {useNavigate, useLocation} from "react-router-dom";
import {Paper, Box, Pagination, TextField, InputAdornment, Typography, useTheme} from "@mui/material";
import CustomButton from "../../../core/components/ui/CustomButton";
import AddIcon from "@mui/icons-material/Add";
import CustomTableLoaderComponent from "../../../core/components/common/custom-table-loader.component";
import ListVehicleComponent from "../components/list-vehicle.component";
import useVehicle from "../hooks/useVehicle";
import useVehicleStore from "../zustand/useVehicleStore";
import CustomTypography from "../../../core/components/ui/CustomTypography";
import { RBACUIGuard } from "../../RBACPlugin";
import { permissions } from "../../../core/components/common/variables/static_variables";
import CustomFilterComponent from "../../../core/components/common/custom-filter.component";


const headers = ["Plate Number", "Model & Manufacturer", "Vehicle Type", "Status", "Actions"];

const VehiclePage = (props) => {
    const {isMobile, breakpoints} = props;
    const navigate = useNavigate();
    const location = useLocation();

    const theme = useTheme();

    const {isFetchingVehicleList, vehicleListData, listVehicle, vehicleTypes, getVehicleTypes, isFilteringVehicle, filterVehicle} = useVehicle();
    
    const {isVehicleCreated, isVehicleStatusUpdated} = useVehicleStore();

    const [vehicleList, setVehicleList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);

    const [filterLabel, setFilterLabel] = useState(null);
    const [filter, setFilter] = useState(null);
    const [plateNumberFilterValue, setPlateNumberFilterValue] = useState(null);
    const [modelFilterValue, setModelFilterValue] = useState(null);
    const [typeFilterValue, setTypeFilterValue] = useState(null);
    const [statusFilterValue, setStatusFilterValue] = useState(null);

    const [vehicleTypeData, setVehicleTypeData] = useState([]);
    const [searchTrigger, setSearchTrigger] = useState(false);

    const rowsPerPage = 10;

    const rbacStorage = JSON.parse(localStorage.getItem("rbac-storage"));
    const storedOrgIdFromRBACForBusiness = rbacStorage?.state?.currentProfile?.orgId || null;
    const orgIdFromUrlForPortEmployee = new URLSearchParams(location.search).get("org_uid");


    const searchForOptions = [
        {value: "plate_number", label: "Plate Number"},
        {value: "model_manufacturer", label: "Model & Manufacturer"},
        {value: "type", label: "Vehicle Type"},
        {value: "status", label: "Status"},
    ]

    const vehicleStatusData = [
        {value: "Active", label: "Active"}, 
        {value: "Deactivated", label: "Deactivated"},
        {value: "Suspended", label: "Suspended"},
        {value: "Removed", label: "Removed"}
    ]

    // track previous filter values
    const filterRef = useRef({
        filterType: null,
        vehicleType: null,
        status: null,
        plateNumber: null,
        model: null,
    });

    useEffect(() => {
        const organizationId = storedOrgIdFromRBACForBusiness || orgIdFromUrlForPortEmployee;

        if (organizationId) {
            const parameters = {
                page: 1,
                limit: rowsPerPage,
                orgUID: organizationId,
            };

            listVehicle(parameters);

        } else if (!organizationId) {
            const parameters = {
                page: 1,
                limit: rowsPerPage,
            };

            listVehicle(parameters);
        }

        getVehicleTypes();
    }, [storedOrgIdFromRBACForBusiness, orgIdFromUrlForPortEmployee]);

    useEffect(() => {
        if (vehicleTypes) {
            const formattedVehicleTypes = vehicleTypes.map(type => ({value: type.toLowerCase(), label: type}));
            setVehicleTypeData(formattedVehicleTypes);
        }
    }, [vehicleTypes])

    useEffect(() => {
        console.log("vehicleListData bbbb", vehicleListData);
        
        if (vehicleListData) {
            setVehicleList(vehicleListData?.content);
            setTotalPages(vehicleListData?.totalPages);
        }  
    }, [vehicleListData])


    // New enhanced code for filters and pagination //

    // single useEffect for filters
    useEffect(() => {
        filterRef.current = {
            filterType: filter,
            vehicleType: typeFilterValue,
            status: statusFilterValue,
            plateNumber: plateNumberFilterValue,
            model: modelFilterValue,
        };

        setCurrentPage(1); // reset pagination
        setSearchTrigger((prev) => !prev); // trigger search
    }, [
      typeFilterValue,  
      statusFilterValue,  
    ])

    useEffect(() => {
        const organizationId = storedOrgIdFromRBACForBusiness || orgIdFromUrlForPortEmployee;

        const filters = filterRef.current;
        console.log("filters bbb", filters);
        
        const filtersApplied = filters.vehicleType || filters.status || filters.plateNumber || filters.model;

        if (filtersApplied) {
            const parameters = {
                page: currentPage,
                limit: rowsPerPage,
                searchFor: filters.filterType,
                searchVal:
                    filters.vehicleType ||
                    filters.status ||
                    filters.plateNumber ||
                    filters.model ||
                    "",
                ...(organizationId && { orgUID: organizationId }),
            };

            filterVehicle(parameters);
        } else {
            const parameters = {
                page: currentPage,
                limit: rowsPerPage,
                ...(organizationId && { orgUID: organizationId }),
            };

            listVehicle(parameters);
        }
    }, [
        searchTrigger,
        currentPage,
        rowsPerPage,
        storedOrgIdFromRBACForBusiness,
        orgIdFromUrlForPortEmployee,
        isVehicleCreated,
        isVehicleStatusUpdated,
    ]);


    // Old code two separate useEffects
    // useEffect(() => {
    //     const organizationId = storedOrgIdFromRBACForBusiness || orgIdFromUrlForPortEmployee;

    //     if (organizationId && (currentPage || isVehicleCreated || isVehicleStatusUpdated)) {
    //         const parameters = {
    //             page: currentPage,
    //             limit: rowsPerPage,
    //             orgUID: organizationId,
    //         };

    //         listVehicle(parameters);

    //     } else if (!organizationId && (currentPage || isVehicleCreated || isVehicleStatusUpdated)) {
    //         const parameters = {
    //             page: currentPage,
    //             limit: rowsPerPage,
    //         };

    //         listVehicle(parameters);
    //     }
    // }, [storedOrgIdFromRBACForBusiness, orgIdFromUrlForPortEmployee, currentPage, isVehicleCreated, isVehicleStatusUpdated])

    // useEffect(() => {
    //     const organizationId = storedOrgIdFromRBACForBusiness || orgIdFromUrlForPortEmployee;

    //     if (organizationId) {
    //         if (filter && typeFilterValue) {
    //             const parameters = {
    //                 page: 1,
    //                 limit: 20,
    //                 searchFor: filter,
    //                 searchVal: typeFilterValue,
    //                 orgUID: organizationId
    //             }
                
    //             filterVehicle(parameters);
            
    //         } else if (filter && statusFilterValue) {
    //             const parameters = {
    //                 page: 1,
    //                 limit: 20,
    //                 searchFor: filter,
    //                 searchVal: statusFilterValue,
    //                 orgUID: organizationId
    //             }
                
    //             filterVehicle(parameters);
    //         }

    //     } else {
    //         if (filter && typeFilterValue) {
    //             const parameters = {
    //                 page: 1,
    //                 limit: 20,
    //                 searchFor: filter,
    //                 searchVal: typeFilterValue
    //             }
                
    //             filterVehicle(parameters);
        
    //         } else if (filter && statusFilterValue) {
    //             const parameters = {
    //                 page: 1,
    //                 limit: 20,
    //                 searchFor: filter,
    //                 searchVal: statusFilterValue
    //             }
                
    //             filterVehicle(parameters);
    //         }
    //     }
    // }, [typeFilterValue, statusFilterValue, storedOrgIdFromRBACForBusiness, orgIdFromUrlForPortEmployee])


    const handleChangePagination = (event, page) => { 
        setCurrentPage(page); 
    }

    const handleAddVehicle = () => {
        if (orgIdFromUrlForPortEmployee && !storedOrgIdFromRBACForBusiness) {
            navigate("/organization/view/vehicles/create?org_uid=" + orgIdFromUrlForPortEmployee);

        } else {
            navigate("/vehicles/create");
        }
    }

    const handleSearchForOption = (selectedOption, type) => { 
        filterRef.current = {
            filterType: selectedOption?.value,
            vehicleType: typeFilterValue,
            status: statusFilterValue,
            plateNumber: plateNumberFilterValue,
            model: modelFilterValue,
        };

        if (selectedOption && type === "type") {
            setFilter(selectedOption.value);
            setFilterLabel(selectedOption.label);
            setStatusFilterValue(null);

        } else if (selectedOption && type === "status") {
            setFilter(selectedOption.value);
            setFilterLabel(selectedOption.label);
            setTypeFilterValue(null);

        } else {    
            handleSearchForClearFilter();
        }
    }

    const handleSearchForClearFilter = (e) => {
        setFilter(null);
        setFilterLabel(null);

        const organizationId = storedOrgIdFromRBACForBusiness || orgIdFromUrlForPortEmployee;

        if (organizationId) {
            const parameters = {
                page: 1,
                limit: rowsPerPage,
                orgUID: organizationId
            }

            listVehicle(parameters);

        } else {
            const parameters = {
                page: 1,
                limit: rowsPerPage,
            }

            listVehicle(parameters);
        }
    }

    const handleSearchValOption = (selectedOption, type) => {
        setModelFilterValue(null);
        setPlateNumberFilterValue(null);

        if (selectedOption && type === "type") {
            setTypeFilterValue(selectedOption.label);
            setStatusFilterValue(null);
        } else if (selectedOption && type === "status") {
            setStatusFilterValue(selectedOption.label); 
            setTypeFilterValue(null);
        } else {    
            handleSearchValClearFilter();
        }
    }

    const handleSearchValClearFilter = (e) => {
        setTypeFilterValue(null);
        setStatusFilterValue(null);
        setPlateNumberFilterValue("");
        setModelFilterValue("");

        const organizationId = storedOrgIdFromRBACForBusiness || orgIdFromUrlForPortEmployee;

        if (organizationId) {
            const parameters = {
                page: 1,
                limit: rowsPerPage,
                orgUID: organizationId
            }

            listVehicle(parameters);

        } else {
            const parameters = {
                page: 1,
                limit: rowsPerPage,
            }

            listVehicle(parameters);
        }
    }

    const handleTextfield = (e, type) => {
        setTypeFilterValue(null);
        setStatusFilterValue(null);

        if (type === "plateNumber") {
            setPlateNumberFilterValue(e.target.value);
            setModelFilterValue("");

        } else if (type === "model") {
            setModelFilterValue(e.target.value);
            setPlateNumberFilterValue("");
        }
    }

    const handleKeyPress = (e, type) => {
        const organizationId = storedOrgIdFromRBACForBusiness || orgIdFromUrlForPortEmployee;

        if (e.keyCode === 13 || e.key === "Enter") {
            // New implementation code
            filterRef.current = {
                filterType: filter,
                vehicleType: typeFilterValue,
                status: statusFilterValue,
                plateNumber: plateNumberFilterValue,
                model: modelFilterValue,
            };

            setCurrentPage(1); // reset pagination
            setSearchTrigger((prev) => !prev); // trigger search

            // Old Code
            // if (organizationId) {
            //     if (filter && type === "plateNumber" && plateNumberFilterValue) {
            //         const parameters = {
            //             page: 1,
            //             limit: 20,
            //             searchFor: filter,
            //             searchVal: plateNumberFilterValue,
            //             orgUID: organizationId
            //         }
                
            //         filterVehicle(parameters);

            //     }  else if (filter && type === "model" && modelFilterValue) {
            //         const parameters = {
            //             page: 1,
            //             limit: 20,
            //             searchFor: filter,
            //             searchVal: modelFilterValue,
            //             orgUID: organizationId
            //         }

            //         filterVehicle(parameters);
            //     }

            // } else {
            //     if (filter && type === "plateNumber" && plateNumberFilterValue) {
            //         const parameters = {
            //             page: 1,
            //             limit: 20,
            //             searchFor: filter,
            //             searchVal: plateNumberFilterValue
            //         }
                
            //         filterVehicle(parameters);

            //     }  else if (filter && type === "model" && modelFilterValue) {
            //         const parameters = {
            //             page: 1,
            //             limit: 20,
            //             searchFor: filter,
            //             searchVal: modelFilterValue
            //         }

            //         filterVehicle(parameters);
            //     }
            // }
        }
    }


    return (
        <>        
            <Box sx={{textAlign: "start"}}>
                <CustomTypography 
                    variant="h3"
                    text={"Vehicles"}
                    customStyles={{
                        marginBottom: 0, 
                    }}
                />

                <CustomTypography 
                    variant="subtitle1"
                    text={"Efficiently manage vehicle assets, assign designated drivers, and seamlessly create new vehicle records"}
                    customStyles={{
                        marginBottom: 0, 
                    }}
                />
            </Box>

            <Paper elevation={0} sx={{border: `1px solid #e5edf6`, borderRadius: 2, padding: "24px 32px", mt: 3}}>
                <Box sx={{display: "flex", justifyContent: "right"}}>
                    <CustomFilterComponent
                        width={250}
                        isSearchable={true}
                        isClearable={true}
                        filterLabel={
                                (filterLabel === "Vehicle Type") ? "Vehicle Type" 
                            :  
                                (filterLabel === "Status") ? "Status" 
                            : 
                                (filterLabel === "Plate Number") ? "Plate Number" 
                            :
                                (filterLabel === "Model & Manufacturer") ? "Model & Manufacturer" 
                            :
                                null
                        }
                        filterOptions={searchForOptions}
                        onChange={selectedOption => handleSearchForOption(selectedOption, filterLabel === "Vehicle Type" ? "type" : "status")}
                        isSearchForFilter={true}
                        isSearchValue={false}
                    />

                    {(filterLabel === null || filterLabel === "Vehicle Type") && 
                        <CustomFilterComponent
                            width={300}
                            isSearchable={true}
                            isClearable={true}
                            filterLabel={filterLabel}
                            filterOptions={vehicleTypeData}
                            onChange={selectedOption => handleSearchValOption(selectedOption, "type")}
                            isSearchForFilter={false}
                            isSearchValue={true}
                            isDisabled={false}
                        />
                    }

                    {(filterLabel === "Status") && 
                        <CustomFilterComponent
                            width={300}
                            isSearchable={true}
                            isClearable={true}
                            filterLabel={filterLabel}
                            filterOptions={vehicleStatusData}
                            onChange={selectedOption => handleSearchValOption(selectedOption, "status")}
                            isSearchForFilter={false}
                            isSearchValue={true}
                            isDisabled={false}
                        />
                    }

                    {(filterLabel === "Plate Number") &&
                        <TextField
                            value={plateNumberFilterValue}
                            placeholder={"Input Plate Number..."}
                            variant="outlined"
                            autoComplete="off"  
                            onChange={(e) => handleTextfield(e, "plateNumber")}
                            onKeyDown={(e) => handleKeyPress(e, "plateNumber")}
                            slotProps={{
                                input: {
                                    style: {
                                        padding: "10px",
                                        fontSize: 14,
                                        fontStyle: 'italic'
                                    },
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Typography sx={{fontSize: 14, color: theme.typography.primary, opacity: 0.85, fontStyle: "normal"}}>
                                                Plate Number:
                                            </Typography>
                                        </InputAdornment>
                                    )
                                }
                            }}
                            sx={{
                                marginRight: "10px", 
                                "& .MuiInputBase-root": {
                                    height: 42, 
                                    backgroundColor: "transparent", 
                                    width: 400, 
                                    borderColor: "#dce8f5"
                                },
                                "& .MuiOutlinedInput-root": {
                                    height: 42,
                                    backgroundColor: "transparent",
                                    "& fieldset": {
                                        borderColor: "#dce8f5",
                                    },
                                    "&:hover fieldset": {
                                        borderColor: theme.palette.primary.main, 
                                    },
                                    "&.Mui-focused fieldset": {
                                        borderColor: `0 0 0 1px ${theme.palette.primary.main}`,
                                    }
                                },
                            }}  
                        /> 
                    }

                    {(filterLabel === "Model & Manufacturer") &&
                        <TextField
                            value={modelFilterValue}
                            placeholder={"Input Model & Manufacturer..."}
                            variant="outlined"
                            autoComplete="off"  
                            onChange={(e) => handleTextfield(e, "model")}
                            onKeyDown={(e) => handleKeyPress(e, "model")}
                            slotProps={{
                                input: {
                                    style: {
                                        padding: "10px",
                                        fontSize: 14,
                                        fontStyle: 'italic'
                                    },
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Typography sx={{fontSize: 14, color: theme.typography.primary, opacity: 0.85, fontStyle: "normal"}}>
                                                Model & Manufacturer:
                                            </Typography>
                                        </InputAdornment>
                                    )
                                }
                            }}
                            sx={{
                                marginRight: "10px", 
                                "& .MuiInputBase-root": {
                                    height: 42, 
                                    backgroundColor: "transparent", 
                                    width: 400, 
                                    borderColor: "#dce8f5"
                                },
                                "& .MuiOutlinedInput-root": {
                                    height: 42,
                                    backgroundColor: "transparent",
                                    "& fieldset": {
                                        borderColor: "#dce8f5",
                                    },
                                    "&:hover fieldset": {
                                        borderColor: theme.palette.primary.main, 
                                    },
                                    "&.Mui-focused fieldset": {
                                        borderColor: `0 0 0 1px ${theme.palette.primary.main}`,
                                    }
                                },
                            }}  
                        /> 
                    }

                    <RBACUIGuard requiredPermission={permissions.vehicle.CREATE_VEHICLE}>
                        <CustomButton 
                            variant="contained" 
                            startIcon={<AddIcon fontSize="small" />}
                            label="Add Vehicle"
                            customStyles={{fontSize: 14}}
                            onClick={handleAddVehicle}
                        />
                    </RBACUIGuard>

                </Box>

                {(isFetchingVehicleList || isFilteringVehicle) ?
                    <Box sx={{mt: 3}}>
                        <CustomTableLoaderComponent 
                            headers={headers} 
                            hasAction={false}
                        /> 
                    </Box>
                :   
                    <Box sx={{mt: 3, mb: (vehicleList?.length === 0 || vehicleList === undefined) ? 2 : {}}}>
                        <ListVehicleComponent 
                            headers={headers} 
                            data={vehicleList} 
                            isMobile={isMobile}
                            breakpoints={breakpoints}
                        />

                        {vehicleList?.length > 0 &&
                            <Pagination
                                count={totalPages}
                                page={currentPage}
                                onChange={handleChangePagination}
                                sx={{
                                    margin: "auto",
                                    width: "fit-content",
                                    paddingTop: 3,

                                    "& .MuiPaginationItem-root.Mui-selected": {
                                        backgroundColor: "#0b99da",      
                                        color: "#fff",               
                                    }
                                }}
                            />
                        }
                    </Box>
                }
            </Paper>
       </>
    )
}

export default VehiclePage